import { FC, SVGProps } from 'react';

export const WaitlistIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H10C10.4142 7.25 10.75 7.58579 10.75 8C10.75 8.41421 10.4142 8.75 10 8.75H4C3.58579 8.75 3.25 8.4142 3.25 8Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.25 23C3.25 22.5858 3.58579 22.25 4 22.25H10C10.4142 22.25 10.75 22.5858 10.75 23C10.75 23.4142 10.4142 23.75 10 23.75H4C3.58579 23.75 3.25 23.4142 3.25 23Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.25 13C3.25 12.5858 3.58579 12.25 4 12.25H13C13.4142 12.25 13.75 12.5858 13.75 13C13.75 13.4142 13.4142 13.75 13 13.75H4C3.58579 13.75 3.25 13.4142 3.25 13Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.25 18C3.25 17.5858 3.58579 17.25 4 17.25H13C13.4142 17.25 13.75 17.5858 13.75 18C13.75 18.4142 13.4142 18.75 13 18.75H4C3.58579 18.75 3.25 18.4142 3.25 18Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14 4.85001C14 4.43579 14.3358 4.10001 14.75 4.10001H28.25C28.6642 4.10001 29 4.43579 29 4.85001C29 5.26422 28.6642 5.60001 28.25 5.60001V9.50001C28.25 9.69892 28.171 9.88968 28.0303 10.0303L22.5607 15.5L28.0303 20.9697C28.171 21.1103 28.25 21.3011 28.25 21.5V25.5C28.25 25.5693 28.2406 25.6363 28.223 25.7H28.25C28.6642 25.7 29 26.0358 29 26.45C29 26.8642 28.6642 27.2 28.25 27.2H14.75C14.3358 27.2 14 26.8642 14 26.45C14 26.0358 14.3358 25.7 14.75 25.7H14.777C14.7594 25.6363 14.75 25.5693 14.75 25.5V21.5C14.75 21.3011 14.829 21.1103 14.9697 20.9697L20.4393 15.5L14.9697 10.0303C14.829 9.88968 14.75 9.69892 14.75 9.50001V5.60001C14.3358 5.60001 14 5.26422 14 4.85001ZM16.25 6.25001V9.18935L21.5 14.4393L26.75 9.18935V6.25001H16.25ZM21.5 16.5607L16.25 21.8107V24.75H26.75V21.8107L21.5 16.5607Z"
			fill="currentColor"
		/>
	</svg>
);
